export const FrameLoaderRequestStrategy = {
  PRIORITY_LAST: 'priorityLastRequest',
  CONCURRENT: 'concurrentRequests',
} as const
export type FrameLoaderStrategy =
  (typeof FrameLoaderRequestStrategy)[keyof typeof FrameLoaderRequestStrategy]

export type FramesLoaderConfig = {
  hqOnly?: boolean
  dicomVolumePrefetching?: boolean
  hardwareConcurrency?: number
  strategy?: FrameLoaderStrategy
}

export type Frame = { hq_url: string; lq_url?: string; section_index: number }
